(function () {
    // ▼ Configure both experiments here (24h each)
    var EXPS = [
      { key: 'pw_lock', params: ['utm_medium'], ttlDays: 1 },
    ];

    try {
      var qs = new URLSearchParams(location.search);
      var now = Date.now();

      // Optional: quick reset via ?utm_reset=1 for QA
      var shouldReset = qs.get('utm_reset') === '1';

      EXPS.forEach(function (EXP) {
        var prefix = 'vx__' + EXP.key + '__';
        var tsKey = prefix + 'ts';

        // --- reset if requested ---
        if (shouldReset) {
          (EXP.params || []).forEach(function (name) {
            localStorage.removeItem(prefix + name);
          });
          localStorage.removeItem(tsKey);
          return;
        }

        // --- persist only this experiment's params (last click wins) ---
        var wrote = false;
        (EXP.params || []).forEach(function (name) {
          var val = (qs.get(name) || '').trim();
          if (val) {
            localStorage.setItem(prefix + name, val);
            wrote = true;
          }
        });
        if (wrote) localStorage.setItem(tsKey, String(now));

        // --- 24h TTL expiry ---
        var ts = +localStorage.getItem(tsKey) || 0;
        if (ts && now - ts > (EXP.ttlDays || 1) * 24 * 60 * 60 * 1000) {
          (EXP.params || []).forEach(function (name) {
            localStorage.removeItem(prefix + name);
          });
          localStorage.removeItem(tsKey);
          return; // don't mirror expired values
        }

        // --- mirror ONLY this experiment's params back into the URL (no reload) ---
        var url = new URL(location.href),
          changed = false;
        (EXP.params || []).forEach(function (name) {
          var stored = localStorage.getItem(prefix + name);
          if (stored && !url.searchParams.get(name)) {
            url.searchParams.set(name, stored);
            changed = true;
          }
        });
        if (changed) history.replaceState(null, '', url.toString());
      });
    } catch (e) {
      /* fail silently */
    }
  })();